<template>
  <div class="home">
    <el-container>
      <!-- 导航栏 -->
      <div class="nav">
        <el-header height="81px">
          <img src="../assets/logo.png" alt="" class="logoImg">
          <div class="navBox">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#409EFF">
              <el-menu-item index="1">{{$t('home.nav1')}}</el-menu-item>
              <el-menu-item index="2">{{$t('home.nav2')}}</el-menu-item>
              <el-menu-item index="3">{{$t('home.nav3')}}</el-menu-item>
              <el-menu-item index="4">{{$t('home.nav4')}}</el-menu-item>
              <el-menu-item index="5">{{$t('home.nav5')}}</el-menu-item>
            </el-menu>
          </div>
          <div class="navRight">
            <span @click="changeType('cn')">简</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="changeType('mo')">繁</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="changeType('en')">EN</span>
          </div>
        </el-header>
      </div>
      <!-- 内容区 -->
      <div class="cent">
        <item1 v-if="index == '1'"></item1>
        <item2 v-if="index == '2'"></item2>
        <item3 v-if="index == '3'"></item3>
        <item4 v-if="index == '4'"></item4>
        <item5 v-if="index == '5'"></item5>
      </div>
    </el-container>
  </div>
</template>

<script>
import item1 from '@/components/item1.vue'
import item2 from '@/components/item2.vue'
import item3 from '@/components/item3.vue'
import item4 from '@/components/item4.vue'
import item5 from '@/components/item5.vue'
export default {
  name: 'HomeView',
  components: { item1, item2, item3, item4, item5 },
  data () {
    return {
      activeIndex: '1',
      title: '投资者关系',
      index: '1',
      isEn: false
    }
  },
  created () {
    if (!localStorage.getItem('locale')) {
      localStorage.setItem('locale', 'cn')
    }
    switch (this.$i18n.locale) {
      case 'cn':
        document.title = '山西省安装集团股份有限公司-投资者关系'
        break
      case 'mo':
        document.title = '山西省安裝集團股份有限公司-投資者關係'
        break
      case 'en':
        document.title = 'Shanxi Installation Group Co., Ltd. - Investor Relations'
        break
      default:
        break
    }
  },
  methods: {
    changeType (type) {
      localStorage.setItem('locale', type)
      this.$i18n.locale = type // 修改页面需要显示的语言
      this.lan = this.$i18n.locale
      document.title = this.$t('title')// 浏览器标题国际化
    },
    handleSelect (key, keyPath) {
      this.index = key
    }
  }
}
</script>
<style scoped>
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-dropdown-menu__item, .el-menu-item{
  font-size: 20px;
  /* font-weight: bold; */
  color: #656565;
  padding: 0 20px;
  cursor: pointer;
}
.el-menu--horizontal>.el-menu-item{
  height: 80px;
  line-height: 80px;
}
.nav{
  width: 100%;
  height: 61px;
  border-bottom: solid 1px #e6e6e6;
  position: fixed;
  box-shadow: 0 0 5px 3px rgb(0 0 0 / 15%);
  background-color: white;
  padding: 20px 0 20px 0;
  z-index:999;
}
.logoImg {
  width: 170px;
    height: 75px;
    position: absolute;
    left: 50px;
    top: 13px;
}
.navBox{
  min-width: 28%;
  position: absolute;
  right: 20%;
  font-size: 18px;
}
.navRight{
  width: 20%;
  position: absolute;
  right: 50px;
  height: 80px;
  line-height: 80px;
  color: #656565;
  font-size: 18px;
  cursor: pointer;
  /* font-weight: bold; */
}
.navRight span:hover{
  color: #409EFF;
}
.cent{
  width: 100%;
  margin-top: 103px;
}
.container{
  width: 1050px;
  margin: 0 auto;
  padding: 80px 0;
}
.descript-title{
  width: 100%;
  font-size: 37px;
  color: #000000;
  line-height: 55px;
  letter-spacing: 0.4375rem;
}
.descript-content{
  width: 100%;
  font-size: 16px;
  color: #656565;
  line-height: 24px;
}
.descript-btm{
  margin-top: 20px;
}
.descript-item{
  background-color: #f9f9f9;
  width: 100%;
  height: 120px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.descript-item-top{
    font-size: 35px;
    color: #ff9faa;
    line-height: 45px;
}
.descript-item-mid{
  font-size: 14px;
    color: #ff9faa;
    line-height: 24px;
    height: 24px;
}
.descript-item-btm{
  font-size: 14px;
  color: #494949;
  line-height: 30px;
}
</style>
